import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().email("Invalid email address"),
  password: z.string().min(6, "Password must be at least 6 characters"),
});

export const signupSchema = z.object({
  name: z.string().min(2, "Name is required"),
  email: z.string().email("Invalid email address"),
  password: z.string().min(6, "Password must be at least 6 characters"),
  confirmPassword: z.string().min(6, "Confirm your password"),
}).refine((data) => data.password === data.confirmPassword, {
  path: ["confirmPassword"],
  message: "Passwords do not match",
});

export const contactSchema = z.object({
  fullName: z.string().min(2, "Full name must be at least 2 characters"),
  email: z.string().email("Invalid email address"),
  subject: z.string().min(3, "Subject must be at least 3 characters"),
  message: z.string().min(10, "Message must be at least 10 characters"),
});

export const newsletterFooterSchema = z.object({
  email: z.string().email("Invalid email address"),
});

const tradingExperienceEnum = z.enum([
  "beginner",
  "intermediate",
  "advanced",
  "professional",
]);

export const updateProfileSchema = z.object({
  fullName: z
    .string()
    .trim()
    .min(1, "Full name is required")
    .max(120, "Full name must be at most 120 characters"),
  email: z.string().trim().email("Invalid email address"),
  country: z.string().optional(),
  bio: z.string().max(1000, "Bio must be at most 1000 characters"),
  tradingExperience: z.union([tradingExperienceEnum, z.literal("")]),
  notifyReviewReplies: z.boolean(),
  notifyPromoCodes: z.boolean(),
});